import { SxProps, Tabs, Theme } from "@mui/material";
import React, { PropsWithChildren } from 'react';

export type TabBarProps = {
    value: any,
    variant?: "standard" | "fullWidth" | "scrollable" | undefined;
    sx?: SxProps<Theme>;
    onChange?: (event: React.SyntheticEvent, value: any) => void;
};

export default function TabBar({
    value,
    variant,
    sx,
    onChange,
    children
}: PropsWithChildren<TabBarProps>) {

    return (
        <Tabs
            value={value}
            indicatorColor="secondary"
            textColor="inherit"
            variant={variant ?? "scrollable"}
            // scrollButtons="auto"
            scrollButtons={false}
            onChange={onChange}
            sx={{
                ...sx,
                borderBottom: "1px solid",
                borderBottomColor: "divider"
            }}
        >
            {children}
        </Tabs >
    );
}
